import React from "react";
import { SEGMENT_BZA, SEGMENT_BZA_ID, SEGMENT_CMC, SEGMENT_CMC_ID } from "../constants";
import CommercialAircraftData from "./CommercialAircraftData";
import SegmentedProductPage from "../SegmentedProductPage";
import BusinessAircraftData from "./BusinessAircraftData";
import { productPageProps } from "../../common/types/product";

export default function AircraftData({
	packageName,
	subscribeLink,
	testimonials,
}: productPageProps) {
	return (
		<SegmentedProductPage
			tabsDefinition={[
				{
					id: SEGMENT_CMC_ID,
					title: `${SEGMENT_CMC} ${packageName}`,
					renderContent: (tabsNav) => (
						<CommercialAircraftData
							packageName={packageName}
							subscribeLink={subscribeLink}
							tabsNav={tabsNav}
							testimonials={testimonials}
						/>
					),
				},
				{
					id: SEGMENT_BZA_ID,
					title: `${SEGMENT_BZA} ${packageName}`,
					renderContent: (tabsNav) => (
						<BusinessAircraftData
							packageName={packageName}
							subscribeLink={subscribeLink}
							tabsNav={tabsNav}
							testimonials={testimonials}
						/>
					),
				},
			]}
		/>
	);
}
